import "../../../css/buttons/PrimaryButton.css";

const BOOKING_URL =
  "https://bookings.cloud.microsoft/bookwithme/user/fa2261725ab84f21bb747357792d358b%40akmortgages.uk?anonymous&ismsaljsauthenabled";

const scrollToContact = () => {
  document
    .getElementById("contact-us")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const PrimaryButton = ({
  onClick,
  text,
  type = "button",
  className = "",
  ...buttonProps
}) => {
  const handleClick =
    onClick ||
    (() => {
      const label = text?.toLowerCase() || "";

      if (label.includes("book a free initial appointment")) {
        window.open(BOOKING_URL, "_blank");
        return;
      }

      // Primary calls-to-action without a page-specific handler should lead
      // visitors to the enquiry form (for example, "Speak to an adviser").
      scrollToContact();
    });

  return (
    <button
      type={type}
      className={`primary-button ${className}`.trim()}
      onClick={handleClick}
      {...buttonProps}
    >
      <div className="button-text">{text}</div>
    </button>
  );
};

export default PrimaryButton;
